export enum IdStatoRichiestaRettifica {
  Bozza = 1,
  In_Approvazione,
  Approvata,
  Rifiutata,
  In_Approvazione_RCD,
}
